<template>
  <div class="card management-card">
    <div>
      <div
        class="card__header"
        :class="{'alternate__header' : alternateStyle}"
        v-if="headline"
      >
        <h2
          :class="headlineClass"
          v-text="headline"
        />
        <slot name="header" />
      </div>
      <div
        class="card__content"
        :class="{'alternate__content': alternateStyle}"
      >
        <slot name="main" />
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    headline: {
      type: String,
      default() {
        return null
      }
    },
    headlineClass: {
      type: String,
      default() {
        return 'h4 h4--underline'
      }
    },
    alternateStyle: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss">
.management-card {
  background-color: $color__white;
  transition: transform .3s;
  box-shadow: $shadow-default;
  margin: 0 $default-margin-padding-width-small 1.25rem;
  position: relative;
  flex: 0 0 calc(50% - (#{$default-margin-padding-width-small} * 2));

  p {
    margin-block: .5em;
  }

  .card__header {
    padding: 1rem;
    max-width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;

    h2 {
      margin: 0;
    }
  }

  .alternate__header {
    padding: 1rem 1rem .5rem;
    max-width: 100%;
    display: inline-block;
  }

  .card__content {
    padding: 1rem;
    display: flex;
    flex-direction: column;

    .content__flex {
      display: flex;
      flex-flow: row wrap;

      .spacer {
        margin-right: .9375rem;
      }
    }

    .button__container {
      justify-content: center;
      margin-top: 1rem;

      .k-button {
        @include breakpoint-down($md) {
          min-width: 7rem;
        }
      }
    }
  }

  .alternate__content {
    padding: 0 1rem;
  }

  @include breakpoint-down($md) {
    margin: 0 0 1.25rem;
    flex: 0 1 100%;
  }
}
</style>
